import React from "react";
import { image } from "../../../../datos";
import { getUploadUrl } from "../../../../utils";
import { useFormatoParrafo } from "../../../../hooks";
import { useNavigate } from "react-router-dom";

const STATUS_MAP = {
  nuevo:        { label: "Nuevo",        bg: "bg-[#151C84]/10",   text: "text-[#151C84]",  dot: "bg-[#151C84]" },
  revision:     { label: "En Revisión",  bg: "bg-amber-50",      text: "text-amber-700",  dot: "bg-amber-500" },
  entrevistado: { label: "Entrevistado", bg: "bg-purple-50",     text: "text-purple-700", dot: "bg-purple-500" },
  seleccionado: { label: "Seleccionado", bg: "bg-emerald-50",    text: "text-emerald-700",dot: "bg-emerald-500" },
  contratado:   { label: "Contratado",   bg: "bg-[#C81416]/10",   text: "text-[#C81416]",  dot: "bg-[#C81416]" },
  descartado:   { label: "Descartado",   bg: "bg-red-50",        text: "text-red-700",    dot: "bg-red-500" },
  archivado:    { label: "Archivado",    bg: "bg-gray-100",      text: "text-gray-600",   dot: "bg-gray-400" },
};

export function GestionHumanaItem(props) {
  const { formulario } = props;
  const navigate = useNavigate();
  const accion = formulario.accion?.toLowerCase();
  const status = STATUS_MAP[accion] || { label: accion || "Sin estado", bg: "bg-gray-100", text: "text-gray-600", dot: "bg-gray-400" };

  return (
    <div className="group bg-white border border-gray-100 rounded-xl p-4 hover:shadow-[0_4px_20px_rgba(21,28,132,0.1)] hover:border-[#151C84]/15 transition-all duration-200 flex items-center justify-between gap-4">
      <div className="flex items-center gap-4 min-w-0">
        {/* Avatar */}
        <div className="relative flex-shrink-0">
          <img
            src={formulario.fileAvatar ? getUploadUrl(formulario.fileAvatar) : image.noAvatar}
            alt={`${formulario.nombre} ${formulario.apellido}`}
            className="w-14 h-14 rounded-xl object-cover border border-gray-200"
          />
          {/* Status dot */}
          <span className={`absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full border-2 border-white ${status.dot}`} />
        </div>

        {/* Info */}
        <div className="min-w-0">
          <h3 className="text-sm font-bold text-gray-900 leading-tight truncate">
            {useFormatoParrafo(formulario.nombre)} {useFormatoParrafo(formulario.apellido)}
          </h3>
          <p className="text-xs text-gray-400 truncate mt-0.5">{formulario.correo_electronico}</p>
          <div className="flex items-center gap-2 mt-2 flex-wrap">
            <span className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 text-[11px] font-semibold rounded-lg ${status.bg} ${status.text}`}>
              <span className={`w-1.5 h-1.5 rounded-full ${status.dot}`} />
              {status.label}
            </span>
            {formulario.telefono1 && (
              <span className="text-[11px] text-gray-400 font-medium">
                {formulario.telefono1}
              </span>
            )}
            {formulario.analisis_ia && (
              <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-purple-700 bg-purple-50 px-2 py-0.5 rounded-lg border border-purple-100">
                <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
                IA
              </span>
            )}
          </div>
        </div>
      </div>

      <button
        onClick={() => navigate(`/admin/gestionhumana/${formulario.id}`)}
        className="flex-shrink-0 flex items-center gap-2 px-4 py-2 bg-[#151C84] text-white text-xs font-bold rounded-xl hover:bg-[#0d125c] transition-all duration-200 shadow-sm hover:shadow-[0_4px_12px_rgba(21,28,132,0.3)] hover:-translate-y-0.5 group-hover:shadow-[0_4px_12px_rgba(21,28,132,0.2)]"
      >
        Ver Perfil
        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  );
}
